import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "translateEnum" })
export class TranslateEnum implements PipeTransform {
  transform(value: any, enumObj: any): any {
    return this.enumToEnumModelArray(value, enumObj);
  }

  enumToEnumModelArray(value: number, enumObj: any): string {
    return Object.keys(enumObj)
      .filter((key) => !isNaN(Number(enumObj[key])))
      .find((x) => enumObj[x] === value);
  }
}
